import { FirebaseDocumentDataType, FirebaseSnapshotType } from 'firebase/index'
import { StockType } from 'types/stock'

const mergeStocks = (snapshots: FirebaseDocumentDataType, isExcludingDeletedStock?: boolean): StockType[] => {
  const stocks: StockType[] = []
  snapshots.forEach((snapshot: FirebaseSnapshotType) => {
    const data = snapshot.data() as StockType
    if (isExcludingDeletedStock && data.is_deleted) return
    data.stock_ref = snapshot.ref
    stocks.push(data)
  })
  return stocks
}

export default mergeStocks
